import { FC } from 'react'

import { Reservation } from 'src/types/reservation'

import css from './OrderDetails.styles.scss'

import PurchaseDetailsSection from '../PurchaseDetailsSection'
import ShipmentDetailsSection from '../ShipmentDetailsSection'

const OrderDetails: FC<{ reservation: Reservation }> = ({ reservation }) => (
  <div className={css.OrderDetails}>
    <PurchaseDetailsSection reservation={reservation} />
    {reservation.shipments && (
      <ShipmentDetailsSection shipments={reservation.shipments} />
    )}
  </div>
)

export default OrderDetails
